import { render, staticRenderFns } from "./head_shoulder_tool.vue?vue&type=template&id=37e77c98"
import script from "./head_shoulder_tool.vue?vue&type=script&lang=js"
export * from "./head_shoulder_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports